import { render, staticRenderFns } from "./ContainerEncuesta.vue?vue&type=template&id=036fa1ed&scoped=true"
import script from "./ContainerEncuesta.vue?vue&type=script&lang=js"
export * from "./ContainerEncuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036fa1ed",
  null
  
)

export default component.exports